export const styles = theme => ({
  divider: {
    margin: `${theme.spacing(1)} 0`,
  },
});
